import React, { useEffect, useState } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { TP_COLORS } from '../../../../constants/Color';
import GetBreakPointName from '../../../../theme/getBreakpoint';
import TutorCardSkeleton from './TutorCardSkeleton';

const messages = ['Goals', 'Strengths', 'Learning Style', 'Study needs'];

const TutorsLoader: React.FC = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const rowData = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 3,
  };

  const breakPoint = GetBreakPointName();

  const skeletonCount = rowData[breakPoint];

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F8FAFC',
        background: `url('${process.env.PUBLIC_URL}/images/tutorProfile/bg-grid-new.png') 0px -16px repeat-x, linear-gradient(to right, #FFFFFF -2.82%, #DAF4F3 100.08%)`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            gap: 5,
            alignItems: 'center',
            marginTop: '60px',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/onboarding/loading-gif.gif`}
            alt="loader-gif"
            style={{
              width: '150px',
              height: '150px',
            }}
          />
          <Typography
            sx={{
              mb: 2,
              fontSize: {
                xs: '20px',
                sm: '24px',
                md: '34px',
                lg: '40px',
              },
            }}
            fontWeight="800"
            color={TP_COLORS.gray.darken}
          >
            Almost there! Matching you with a tutor <br /> who understands your{' '}
            <span style={{ color: TP_COLORS.tutopiyaGreenMain.darken }}>
              {messages[messageIndex]}
            </span>
          </Typography>
        </Box>
        {/* Skeleton Cards */}
        <Grid container spacing="20px" marginTop="70px">
          {Array.from({ length: skeletonCount }).map((_, index) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={4}>
              <TutorCardSkeleton />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TutorsLoader;
